/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Hire_UpworkInputs */

const en_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hire on Upwork`)
};

const ar_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وظّفني على Upwork`)
};

const bn_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork-এ হায়ার করুন`)
};

const de_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Upwork beauftragen`)
};

const es_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contratar en Upwork`)
};

const fr_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embaucher sur Upwork`)
};

const pt_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrate no Upwork`)
};

const zh_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Upwork 上招聘`)
};

const tr_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork'te İşe Alma`)
};

const ru_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нанимайте на Upwork`)
};

const pl_contact_hire_upwork = /** @type {(inputs: Contact_Hire_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrudnij w Upwork`)
};

/**
* | output |
* | --- |
* | "Hire on Upwork" |
*
* @param {Contact_Hire_UpworkInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_hire_upwork = /** @type {((inputs?: Contact_Hire_UpworkInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Hire_UpworkInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contact_hire_upwork(inputs)
	if (locale === "bn") return bn_contact_hire_upwork(inputs)
	if (locale === "de") return de_contact_hire_upwork(inputs)
	if (locale === "es") return es_contact_hire_upwork(inputs)
	if (locale === "fr") return fr_contact_hire_upwork(inputs)
	if (locale === "pt") return pt_contact_hire_upwork(inputs)
	if (locale === "zh") return zh_contact_hire_upwork(inputs)
	if (locale === "tr") return tr_contact_hire_upwork(inputs)
	if (locale === "ru") return ru_contact_hire_upwork(inputs)
	if (locale === "pl") return pl_contact_hire_upwork(inputs)
	return en_contact_hire_upwork(inputs)
});